import script from "./Layout.vue?vue&type=script&setup=true&lang=js"
export * from "./Layout.vue?vue&type=script&setup=true&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=37afc7e3&scoped=true&lang=scss"

import exportComponent from "H:\\03_微压氧舱-张赟\\共享氧舱\\爱尔威仕\\share-project-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37afc7e3"]])

export default __exports__